"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toEthereumAddress = void 0;
const REGEX = /^0x[a-fA-F0-9]{40}$/;
function toEthereumAddress(str) {
    if (str.match(REGEX)) {
        return str.toLowerCase();
    }
    throw new Error(`not a valid Ethereum address: "${str}"`);
}
exports.toEthereumAddress = toEthereumAddress;
//# sourceMappingURL=EthereumAddress.js.map